import React from 'react';
import PropTypes from 'prop-types';

import styles from './PaymentFlowHeader.scss';

const PaymentFlowHeader = ({ containerSize, activeZeroIndex }) => {
  const steps = ['Enter email', 'Create account', 'Purchase'];
  return (
    <div
      className={`PaymentFlowHeader PaymentFlowHeader--size-${containerSize}`}
    >
      <div className="PaymentFlowHeader__container">
        <h1 className="PaymentFlowHeader__text">
          Subscribe to Tinybop Schools
        </h1>
        <div className="PaymentFlowHeader__steps">
          {steps.map((text, index) => (
            <div
              key={`payment-step-${index}`}
              className="PaymentFlowHeader__step"
              data-active={activeZeroIndex === index}
            >
              {index + 1}. {text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

PaymentFlowHeader.propTypes = {
  containerSize: PropTypes.oneOf(['small', 'medium', 'large']),
  activeZeroIndex: PropTypes.number,
};

PaymentFlowHeader.defaultProps = {
  containerSize: 'small',
  activeZeroIndex: 0,
};

export default PaymentFlowHeader;
